const VoucherTypeErrors = {
    "2": "Invalid card/certificate number",
    "6": "Card expired",
    "CERT_EXPIRED": "Card expired",
    "9": "Card has zero balance",
    "BALANCE_ERROR": "Card has zero balance",
    "19": "Card type not valid for your venue",
    "OPERATION_NOT_PERMITTED": "Card type not valid for your venue",
    "27": "Card on hold, customer to contact issuer",
    "CERT_ON_HOLD": "Card on hold, customer to contact issuer",
    "28": "Card cancelled, customer to contact issuer",
    "CERT_CANCELLED": "Card cancelled, customer to contact issuer",
    "40": "Card not activated, customer to contact issuer",
    "CERT_NOT_ACTIVE": "Card not activated, customer to contact issuer",
    "VOUCHER_NOT_FOR_VENDOR": "This gift certificate is only valid for a specific experience at a different venue, try a different card/certificate",
    "CERT_IS_ALREADY_REDEEMED": "Certificate already used, try a different gift card/certificate",
    "EXPIRED_CERTIFICATE": "Certificate is expired, please try a different card/certificate"
};


export const isInvalidVoucher = (data) => (
    data.IsInvalidVoucher ||
    !data.CanBeRedeemed ||
    data.HasErrors ||
    data.VoucherIsInactive ||
    data.IsExpired
);

export const getVoucherError = (response) => {

    if (response.ErrorCode && response.ErrorCode !== "0")
        return VoucherTypeErrors[response.ErrorCode] || response.ErrorMessage;

    if (response.IsInvalidVoucher)
        return VoucherTypeErrors["2"];

    if (response.IsExpired)
        return VoucherTypeErrors["6"];

    if (!response.CanBeRedeemed)
        return VoucherTypeErrors["2"];

    return null;
};
